import request from 'assets/js/http';

export function logList(data) {
  // 日志列表
  return request({
    url: '/opLog/list',
    method: 'post',
    data
  });
}
